import {GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType} from "../../core/components/toolBar";
import {Config} from "../../core/config/config";
import {DialogHelper} from "../../core/util/dialogHelper";
import {General} from "../../../siteManagement/general";
import {SheetEventType} from "../../../siteManagement/sheet";
import {Helper} from "../../core/util/helper";
import {Grid} from "../../core/components/grid";
import WorkPackageApp, {WorkPackageAppProps} from "../workPackage/workPackage";
import {RecurringTaskEntity, TaskMachine} from "./recurringTask";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { WorkPackageEntity } from "../workPackage/workPackage";
import { Entity } from "../../core/components/commonApp";
import React from "react";

export class WorkPackageGrid extends React.Component<WorkPackageGridProps, WorkPackageGridState>{
    private gridOptions = {};
    
    constructor(props: WorkPackageGridProps | Readonly<WorkPackageGridProps>) {
        super(props);
        this.gridOptions = this.props.gridOptions;
        this.state = { canWriteEnity: true, deleteEnabled: false }
    }

    private edit = async (dataItem: WorkPackageEntity) => {
        if(!await this.props.doSave()) return;
        let entityResult = await HTTPService.get<JsonResultClass<WorkPackageEntity>>(`WorkPackage/Init?id=${dataItem.Id}`);
        if(entityResult.Code !== 0) return;
        await this.openPos(entityResult.Data);
    }

    private openPos = async (dataItem: WorkPackageEntity = null) => {
        let result = await Helper.getMetaData("WorkPackage");
        let entity = dataItem;
        entity.RecordRight.CanRead = true;
        if (!entity.IsNew)
            entity.RecordRight.CanWrite = this.state.canWriteEnity;
        this.initWorkPackageWindow(entity, result);
    }

    loadTaskMachines = (ds: TaskMachine[]) => {
        let machines = [];
        machines.push({Key:null, Value:''});
        for (let i = 0; i < ds.length; i++) {
            machines.push({ Key: ds[i].Machine.MaschNr, Value: ds[i].Machine.MaschBezeichnung });
        }
        return machines;
    }  

    private initWorkPackageWindow = (entity: Entity, metaData: any) => {
        let readOnly = !entity.RecordRight.CanWrite;
        let entityCopy: WorkPackageEntity = JSON.parse(JSON.stringify(entity));
        entityCopy.taskEntity = JSON.parse(JSON.stringify(this.props.entity));
        entityCopy.RecordRight.CanWrite = true;
        let workPackageProps: WorkPackageAppProps = {
            entity: entityCopy,
            metadata: metaData,
            dataSources: { taskMachinesDs: this.loadTaskMachines(this.props.entity.Machines) },
            isWindow: true,
            readOnly: readOnly,
            context: { key1: "entity.Id", keyVal1: entityCopy.Id, standAlone: false, contextType: "workPackage" },
            title: "WorkPackage"
        }
        let sheet = General.Sheet.Manager.createSheet();

        sheet.show(() => {
            sheet.mountContent(WorkPackageApp, workPackageProps);
        });
        sheet.bind(SheetEventType.SavedSuccessfully,
            async (workPackage: WorkPackageEntity) => {
                let didUpdate = false;
                let item = this.props.entity.WorkPackages.find(f=> f.Id === workPackage.Id);
                if (!Helper.hasValue(item)) {
                     if (Helper.hasValue(workPackage.entity)){
                         item = JSON.parse(JSON.stringify(workPackage.entity));
                         if (Helper.hasValue(item)) {
                             if (!Helper.hasValue(this.props.entity.WorkPackages.find(w => w.Id === item.Id))) {
                                 this.props.entity.WorkPackages.push(item);
                                 didUpdate = true;
                             }
                         }
                     }
                } else {
                    item.Id = workPackage.Id;
                    item.Title = workPackage.Title;
                    item.JobDescription = workPackage.JobDescription;
                    item.Description = workPackage.Description;
                    item.CapacityRequirements = workPackage.CapacityRequirements;
                    item.PartRequirements = workPackage.PartRequirements;
                    item.TemplateRequirements = workPackage.TemplateRequirements;
                    item.AllowCombining = workPackage.AllowCombining;
                    item.IndividualFields = workPackage.IndividualFields;
                    didUpdate = true
                }
                if(didUpdate) {
                    this.props.doUpdate(this.props.entity.WorkPackages);
                    await this.props.doSave();
                }
            });
    }

    private createNewPackage = async ()=>{
        if (!await this.props.doSave()) return;
        const entity: WorkPackageEntity = Helper.createEmptyEntity() as WorkPackageEntity;
        entity.Id = kendo.guid();
        entity.CapacityRequirements = [];
        entity.PartRequirements = [];
        entity.TemplateRequirements = [];
        entity.RecordRight.CanWrite = true;
        await this.openPos(entity);
    }

    private handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            await this.createNewPackage();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            await this.edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            await this.deletePos(dataItem.Id);
        }
    }
    private deletePos = async (id: string) => {
        const index = this.props.entity.WorkPackages.findIndex(f => f.Id === id);
        if (index < 0)  return;
        if(! await this.props.doSave())
            return;
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (!isOk) return;
        let result = await HTTPService.post<JsonResultClass<WorkPackageEntity>>("RecurringTask/DeleteWorkPackage",
            {
                taskId: this.props.entity.Id,
                workPackageId: id,
                lockId: this.props.entity.IsId
            });
        if (result.Code !== 0) {
            NotificationHelper.showErrorMessage(result.Message)
            return;
        }
        this.props.entity.WorkPackages.splice(index, 1);
        this.props.doUpdate(this.props.entity.WorkPackages);
    }
    
    
    private selectionChange = (dataItem: WorkPackageEntity) => {
        if (Helper.hasValue(dataItem)) {
            let isSchemaOnce = this.props.entity.RecurrenceSchema.Type === 'RecurrenceSchemaOnceViewModel';
            
            let currentWorkpackageId = isSchemaOnce ? this.props.entity.RecurrenceSchema.WorkPackageId:
                this.props.entity.RecurrenceSchema.SchemaList[this.props.entity.RecurrenceSchema.SchemaList.length-1].WorkPackageId;

            let deleteButtonEnable = this.props.entity.RecordRight.CanWrite && this.props.entity.WorkPackages.length >= 2 && 
                dataItem.Id !== currentWorkpackageId;

            
            
            this.setState({
                canWriteEnity: !dataItem.IsTriggered && this.props.entity.RecordRight.CanWrite, 
                deleteEnabled: !dataItem.IsTriggered && deleteButtonEnable 
            });
        }
    }
    private copyId = "copy";
    private handleCustomButtonClick =  async (id: string, dataItem: WorkPackageEntity) => {
        if (id === this.copyId) {
            if(!await this.props.doSave())
                return;
            
            let result = await HTTPService.post<JsonResultClass<WorkPackageEntity>>("RecurringTask/CopyWorkPackage",
                {
                    taskId: this.props.entity.Id,
                    workPackageId: dataItem.Id,
                    lockId: this.props.entity.IsId 
                });
            if (result.Code === 0) {
                this.props.entity.WorkPackages.push(result.Data);
                this.props.doUpdate(this.props.entity.WorkPackages)
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }
    render() {

        const standardButtons: Array<ToolBarStandardButton> = [];
        const customButtons: Array<GridCustomToolBarButton> = [];
        let isSchemaOnce = this.props.entity.RecurrenceSchema.Type === 'RecurrenceSchemaOnceViewModel';
        
        
        let enableNewButton = isSchemaOnce ? this.props.entity.RecordRight.CanWrite && this.props.entity.WorkPackages.length == 0 : this.props.entity.RecordRight.CanWrite; 
        let enableCopyButton = !isSchemaOnce ? this.props.entity.RecordRight.CanWrite : false;
        
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: enableNewButton });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: (this.state.canWriteEnity) ? Config.translations.editLabel : Helper.getTranslation("WebCRM.Tasks.WorkPackage.Show"), enabled:true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.deleteEnabled });
        customButtons.push({ autoEnabledOnRecordSelected: true, caption: Config.translations.copyLabel, enabled: enableCopyButton, iconClass: "k-i-redo", id: this.copyId });


        const content = (<div style={{ height: "300px" }}> <Grid data={this.props.entity.WorkPackages} options={this.gridOptions} id="workPackageGrid"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} onSelectionChanged={this.selectionChange}
            customButtons={customButtons} onClickCustomButton={this.handleCustomButtonClick} /></div>);

        return (content);
    }
}

interface WorkPackageGridState {
    gridData?: WorkPackageEntity[];
    canWriteEnity?: boolean;
    deleteEnabled: boolean;
}
export interface WorkPackageGridProps {
    gridOptions:{}
    // lockControl: LockControl;
    entity: RecurringTaskEntity;
    doUpdate: (value: WorkPackageEntity[]) => void
    doSave: ()=>Promise<boolean>
}
